<button class="back-button" mat-icon-button [disabled]="disabled" (click)="onClick(); $event.stopPropagation()">
  <mat-icon>arrow_back_ios</mat-icon>
  {{ 'components.button-back.title' | translate }}
</button>
